module.exports = __webpack_public_path__ + "static/media/antenna.7bb34484.svg";